export default __webpack_public_path__ + "static/digital-white-background-2ec46c6f91001c01071328d7f4ac06c1.png";